module.exports = __webpack_public_path__ + "img/universal-vaccine.6012eb78.jpg";